import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb, Form } from 'antd';
import _ from 'lodash';

import { submitModalState } from 'shared/constant';
import HeaderSteps from 'components/HeaderSteps';
import FormCompanyRegister from './CompanyRegister.form';
import AlertModal from '../../components/AlertModal/AlertModal.component';

import organizationRoute from '../../route';

import text from './CompanyRegister.page.translation';

const VendorRegisterForm = Form.create()(FormCompanyRegister);

export class CompanyRegister extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      companyId: this.props.match.params.id || '',
    };
  }

  componentDidMount() {
    const { resetSubmitModal } = this.props;
    resetSubmitModal();
    if (this.state.companyId) {
      this.props.getSingleCompany(this.state.companyId, this.getSingleEmployee);
    } else {
      this.getAvailableModulesCreate();
    }
  }

  getAvailableModulesCreate = () => {
    this.props.getAvailableModules(this.getEmployeeRole);
  };

  getAvailableModulesEdit = () => {
    this.props.getAvailableModules(this.updateAvailableModulesByCompanyDetails);
  };

  getSingleEmployee = data => {
    const picId = _.get(data, 'payload.pic_id');
    if (picId) {
      this.props.getSingleEmployee(
        data.payload.pic_id,
        this.getAvailableModulesEdit,
      );
    }
  };

  getEmployeeRole = () => {
    this.props.getEmployeeRole('', '', this.updateEmployeeRolesUnchecked);
  };

  filterEmployeeRolesByModules = (employeeRoles, modules, uncheckAll) => {
    const result = [];
    let newRoles;

    if (uncheckAll) {
      newRoles = employeeRoles.map(x => ({
        ...x,
        checked: false,
        hidden: false,
      }));
    } else {
      newRoles = employeeRoles.map(x => ({
        ...x,
        hidden: false,
      }));
    }

    const checkedModuleIds = modules
      .filter(x => x.checked === true)
      .map(x => x.id);

    for (let i = 0; i < newRoles.length; i += 1) {
      const currentRole = newRoles[i];

      if (checkedModuleIds.indexOf(currentRole.module.id) === -1) {
        currentRole.checked = false;
        currentRole.hidden = true;
      }

      result.push(currentRole);
    }

    return result;
  };

  nameSort = roles => roles.name && roles.name.toLowerCase();

  updateEmployeeRolesUnchecked = data => {
    const allRoles = _.get(data, 'payload', []);
    const activeRoles = this.filterDeactivatedRoles(allRoles);

    const employeeRoles = this.filterEmployeeRolesByModules(
      activeRoles,
      this.props.availableModules,
      true,
    );

    const sortedEmployeeRoles = _.orderBy(
      employeeRoles,
      [this.nameSort],
      ['asc'],
    );

    this.props.updateEmployeeRolesAll(sortedEmployeeRoles);
  };

  filterDeactivatedRoles = roles => roles.filter(x => !x.deactivated);

  getCheckedEmployeeRoles = (data, checkedRoles) => {
    const allRoles = data.map(x => ({ ...x, checked: false }));
    for (let i = 0; i < allRoles.length; i += 1) {
      for (let j = 0; j < checkedRoles.length; j += 1) {
        if (allRoles[i].id === checkedRoles[j].id) {
          allRoles[i].checked = true;
          break;
        }
      }
    }

    return allRoles;
  };

  updateEmployeeRolesChecked = (data, checkedRoles) => {
    const newRoles = this.getCheckedEmployeeRoles(data, checkedRoles);
    this.props.updateEmployeeRolesAll(newRoles);
  };

  constructGetEmployeeRolesParams = newModules => {
    const params = {
      page_num: 1,
      page_size: 1000,
    };

    const checkedAudiences = newModules
      .filter(x => x.checked)
      .map(x => x.identifier)
      .join(',');

    if (checkedAudiences) {
      params.audiences = checkedAudiences;
    }

    return params;
  };

  getEmployeeRoleCallback = data => {
    const allRoles = _.get(data, 'payload', []);
    const activeRoles = this.filterDeactivatedRoles(allRoles);

    const employeeRoles = this.filterEmployeeRolesByModules(
      activeRoles,
      this.props.availableModules,
      false,
    );

    this.updateEmployeeRolesChecked(
      employeeRoles,
      this.props.employeeDetails.payload.user_details.user_role,
    );
  };

  updateAvailableModulesByCompanyDetails = () => {
    const { companyDetails } = this.props;
    const newModules = this.updateSelectedModuleByCompanyDetails(
      companyDetails,
    );

    this.props.updateAvailableModules(newModules);
    this.props.getEmployeeRole('', '', this.getEmployeeRoleCallback);
  };

  getModulesParam = () => {
    const result = this.props.availableModules
      .filter(x => x.checked)
      .map(x => ({
        name: x.name,
        identifier: x.identifier,
        view_all: x.view_all || false,
      }));

    return result;
  };

  getApiParams = vendorParams => {
    const params = {};
    const modulesParam = this.getModulesParam();

    params.organization = {
      name: vendorParams.companyName,
      address: vendorParams.companyAddress,
      owner_fullname: vendorParams.companyOwner,
      owner_email: vendorParams.companyEmail.toLowerCase(),
      npwp_number: vendorParams.npwpNumber,
      legal_entity: vendorParams.legalEntity,
      modules: modulesParam,
    };

    params.user = {
      email: vendorParams.picEmail.toLowerCase(),
      roles: vendorParams.employeeRoles.map(x => x.id),
      phone_mobile: vendorParams.picPhone,
    };

    // Name split
    const trimVendorParams = vendorParams.picName.trim();
    const splitName = trimVendorParams.split(' ');
    const firstName = splitName[0];
    let lastName = splitName.shift();
    lastName = splitName.toString();
    lastName = lastName.split(',').join(' ');

    if (lastName === '') {
      lastName += firstName;
    }

    params.employee = {
      firstname: firstName,
      lastname: lastName,
      ktp_num: vendorParams.picNationalID,
    };

    params.avatar = vendorParams.picPicture;

    if (this.state.companyId) {
      params.organization_id = this.state.companyId;
      params.user_id = this.props.employeeDetails.payload.user_details.user_id;
      params.employee_id = this.props.employeeDetails.payload.employee_id;
    }

    return params;
  };

  _handleSubmit = vendorParams => {
    const params = this.getApiParams(vendorParams);

    if (this.state.companyId) {
      this.props.updateCompany(params);
    } else {
      this.props.createNewCompany(params);
    }
  };

  _renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    let breadcrumbText = '';

    if (this.state.companyId) {
      breadcrumbText = formatMessage(text.breadcrumbEdit);
    } else {
      breadcrumbText = formatMessage(text.breadcrumbRegister);
    }

    return (
      <div className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link
              to={organizationRoute.COMPANY_LIST.replace(
                ':tab',
                'view-company',
              )}
            >
              {formatMessage(text.breadcrumbCompanyList)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{breadcrumbText}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );
  };

  updateSelectedModule = (module, checked) => {
    const newModules = this.props.availableModules.map(newModule => ({
      ...newModule,
    }));
    for (let i = 0; i < newModules.length; i += 1) {
      newModules[i].view_all = false;

      if (newModules[i].identifier === module.identifier) {
        newModules[i].checked = checked;
      }
    }

    return newModules;
  };

  updateSelectedModulePermission = (module, checked) => {
    const newModules = this.props.availableModules.map(newModule => ({
      ...newModule,
    }));
    for (let i = 0; i < newModules.length; i += 1) {
      if (newModules[i].identifier === module.identifier) {
        newModules[i].view_all = checked;
        break;
      }
    }

    return newModules;
  };

  updateSelectedModuleByCompanyDetails = companyDetails => {
    const newModules = this.props.availableModules.map(newModule => ({
      ...newModule,
    }));

    const companyModules = companyDetails.payload.modules;

    for (let i = 0; i < newModules.length; i += 1) {
      for (let j = 0; j < companyModules.length; j += 1)
        if (newModules[i].identifier === companyModules[j].identifier) {
          newModules[i].checked = true;
          newModules[i].view_all = companyModules[j].view_all;
          break;
        }
    }

    return newModules;
  };

  onSelectModule = (module, checked) => {
    const newModules = this.updateSelectedModule(module, checked);

    this.props.updateAvailableModules(newModules);

    const employeeRoles = this.filterEmployeeRolesByModules(
      this.props.employeeRoles,
      newModules,
      false,
    );
    this.props.updateEmployeeRolesAll(employeeRoles);
  };

  onSelectPermission = (module, checked) => {
    const newModules = this.updateSelectedModulePermission(module, checked);

    this.props.updateAvailableModules(newModules);
  };

  _renderForm = () => (
    <VendorRegisterForm
      onSubmit={this._handleSubmit}
      onSelectModule={this.onSelectModule}
      onSelectPermission={this.onSelectPermission}
      getModulesParam={this.getModulesParam}
      companyId={this.state.companyId}
      getSubmitModalSteps={this.getSubmitModalSteps}
      onCancelModal={this.onCancelModal}
      {...this.props}
    />
  );

  confirmRollback = () => {
    if (
      this.state.companyId ||
      this.props.submitAddCompanyState === submitModalState.FAILED
    ) {
      this.props.updateSubmitModalErrorOpen(false);
      this.props.updateCreateNewCompanyStep(2);
    } else if (this.props.submitAddUserState === submitModalState.FAILED) {
      this.props.startRollbackOrganization(this.props.createNewCompanyParams);
    } else {
      this.props.startRollbackUser(this.props.createNewCompanyParams);
    }
  };

  renderModalConfirm = () => {
    const {
      intl: { formatMessage },
      rollbackModalOpen,
      cancelRollbackModal,
    } = this.props;

    const title = formatMessage(text.rollbackConfirmationTitle);
    const description = formatMessage(text.rollbackConfirmationDescription);
    const btnOk = formatMessage(text.rollbackConfirmationBtnOk);
    const btnCancel = formatMessage(text.rollbackConfirmationBtnCancel);

    return (
      <AlertModal
        visible={rollbackModalOpen}
        type="confirm"
        title={title}
        description={description}
        primaryBtnText={btnOk}
        primaryBtnClick={this.confirmRollback}
        cancelBtnText={btnCancel}
        cancelBtnClick={cancelRollbackModal}
      />
    );
  };

  renderRollbackModalFinish = () => {
    const {
      intl: { formatMessage },
      rollbackModalFinishOpen,
      isRollbackSuccess,
    } = this.props;

    if (rollbackModalFinishOpen) {
      if (isRollbackSuccess) {
        return (
          <AlertModal
            visible={rollbackModalFinishOpen}
            type="alert"
            title={formatMessage(text.rollbackSuccessTitle)}
            description={formatMessage(text.rollbackSuccessDescription)}
            primaryBtnText={formatMessage(text.rollbackSuccessBtnOk)}
            primaryBtnClick={this.rollbackFinish}
          />
        );
      }

      return (
        <AlertModal
          visible={rollbackModalFinishOpen}
          type="alert"
          title={formatMessage(text.rollbackErrorTitle)}
          description={formatMessage(text.rollbackErrorDescription)}
          primaryBtnText={formatMessage(text.rollbackErrorBtnRetry)}
          primaryBtnClick={this.retryRollback}
        />
      );
    }

    return null;
  };

  rollbackFinish = () => {
    const { rollbackFinish } = this.props;
    rollbackFinish();
  };

  retryRollback = () => {
    const {
      submitAddUserState,
      submitAddCompanyState,
      createNewCompanyParams,
      startRollbackOrganization,
      startRollbackUser,
    } = this.props;

    if (submitAddUserState === submitModalState.ROLLBACK) {
      startRollbackUser(createNewCompanyParams);
    } else if (submitAddCompanyState === submitModalState.ROLLBACK) {
      startRollbackOrganization(createNewCompanyParams);
    }
  };

  onCancelModal = () => {
    this.props.showRollbackModal();
  };

  retryCompany = () => {
    this.props.startRetryCompany(this.props.createNewCompanyParams);
  };

  retryUser = () => {
    this.props.startRetryUser(this.props.createNewCompanyParams);
  };

  retryEmployee = () => {
    this.props.startRetryEmployee(this.props.createNewCompanyParams);
  };

  retryUpdateCompany = () => {
    this.props.startRetryUpdateCompany(this.props.createNewCompanyParams);
  };

  retryUpdateUser = () => {
    this.props.startRetryUpdateUser(this.props.createNewCompanyParams);
  };

  retryUpdateEmployee = () => {
    this.props.startRetryUpdateEmployee(this.props.createNewCompanyParams);
  };

  getSubmitModalSteps = () => {
    const {
      intl: { formatMessage },
    } = this.props;

    if (this.state.companyId) {
      return [
        {
          title: formatMessage(text.updateCompanyModalTitle),
          icon: 'ModalCompanyIcon',
          status: this.props.submitAddCompanyState,
          retry: this.retryUpdateCompany.bind(this),
        },
        {
          title: formatMessage(text.updateUserModalTitle),
          icon: 'ModalUserIcon',
          status: this.props.submitAddUserState,
          retry: this.retryUpdateUser.bind(this),
        },
        {
          title: formatMessage(text.updateEmployeeModalTitle),
          icon: 'ModalEmployeeIcon',
          status: this.props.submitAddEmployeeState,
          retry: this.retryUpdateEmployee.bind(this),
        },
      ];
    }

    return [
      {
        title: formatMessage(text.createCompanyModalTitle),
        icon: 'ModalCompanyIcon',
        status: this.props.submitAddCompanyState,
        retry: this.retryCompany.bind(this),
      },
      {
        title: formatMessage(text.createUserModalTitle),
        icon: 'ModalUserIcon',
        status: this.props.submitAddUserState,
        retry: this.retryUser.bind(this),
      },
      {
        title: formatMessage(text.createEmployeeModalTitle),
        icon: 'ModalEmployeeIcon',
        status: this.props.submitAddEmployeeState,
        retry: this.retryEmployee.bind(this),
      },
    ];
  };

  render() {
    const {
      createNewCompanyStep,
      intl: { formatMessage },
    } = this.props;

    return (
      <div className="main-content" id="company-register-page">
        {this._renderBreadCrumb()}
        <div className="white-box-wrapper">
          <div id="form-register-vendor" className="form-wrapper">
            <HeaderSteps
              currentStep={createNewCompanyStep}
              stepOneTitle={formatMessage(text.companyStepOneTitle)}
              stepOneDescription={formatMessage(text.companyStepOneDescription)}
              stepTwoTitle={formatMessage(text.companyStepTwoTitle)}
              stepTwoDescription={formatMessage(text.companyStepTwoDescription)}
              stepThreeTitle={formatMessage(text.companyStepThreeTitle)}
              stepThreeDescription={formatMessage(
                text.companyStepThreeDescription,
              )}
            />
            {this._renderForm()}
            {this.renderModalConfirm()}
            {this.renderRollbackModalFinish()}
          </div>
        </div>
      </div>
    );
  }
}

CompanyRegister.propTypes = {
  updateCompany: PropTypes.func,
  getSingleCompany: PropTypes.func.isRequired,
  history: PropTypes.object,
  intl: PropTypes.object.isRequired,
  availableModules: PropTypes.array.isRequired,
  getAvailableModules: PropTypes.func.isRequired,
  me: PropTypes.object.isRequired,
  employeeRoles: PropTypes.array.isRequired,
  updateAvailableModules: PropTypes.func.isRequired,
  getAllTokenLoading: PropTypes.bool,
  createNewCompany: PropTypes.func.isRequired,
  submitModalFinishOpen: PropTypes.bool.isRequired,
  updateSubmitModalFinishOpen: PropTypes.func.isRequired,
  submitAddCompanyState: PropTypes.string.isRequired,
  submitAddUserState: PropTypes.string.isRequired,
  submitAddEmployeeState: PropTypes.string.isRequired,
  startRetryCompany: PropTypes.func.isRequired,
  startRetryUser: PropTypes.func.isRequired,
  startRetryEmployee: PropTypes.func.isRequired,
  createNewCompanyParams: PropTypes.object,
  resetAvailableModules: PropTypes.func.isRequired,
  loadingEmployeeRoles: PropTypes.bool,
  showRollbackModal: PropTypes.func,
  rollbackModalOpen: PropTypes.bool,
  cancelRollbackModal: PropTypes.func,
  startRollbackOrganization: PropTypes.func,
  isRollbackSuccess: PropTypes.bool,
  rollbackModalFinishOpen: PropTypes.bool,
  rollbackFinish: PropTypes.func,
  startRollbackUser: PropTypes.func,
  companyDetails: PropTypes.object,
  employeeDetails: PropTypes.object,
  match: PropTypes.object,
  getLoading: PropTypes.bool,
  getSingleEmployee: PropTypes.func,
  getEmployeeRole: PropTypes.func,
  submitModalErrorOpen: PropTypes.bool,
  updateSubmitModalErrorOpen: PropTypes.func,
  startRetryUpdateCompany: PropTypes.func,
  startRetryUpdateUser: PropTypes.func,
  startRetryUpdateEmployee: PropTypes.func,
  createNewCompanyStep: PropTypes.number,
  updateCreateNewCompanyStep: PropTypes.func,
  resetSubmitModal: PropTypes.func,
  updateEmployeeRolesAll: PropTypes.func,
};

export default CompanyRegister;
